/**
 * Query Provider
 * Wraps application with TanStack Query's QueryClientProvider
 */

import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { getQueryClient } from '@/api/http/query-client'
import { isDebugEnabled } from '@/config/config'

interface QueryProviderProps {
  children: React.ReactNode
}

/**
 * QueryProvider component
 * Provides TanStack Query context to the application
 */
export function QueryProvider({ children }: QueryProviderProps) {
  const queryClient = getQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Show DevTools in development mode */}
      {isDebugEnabled() && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}

export default QueryProvider
